import * as runtime from '@/api/runtime'
import {
  BatchTrcContentDetailRegisterRequest,
  BatchTrcContentDetailRegisterRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchTrcContentDetailRegisterCondition,
  BatchTrcContentDetailRegisterConditionFromJSON
} from '@/api/models/batch/BatchTrcContentDetailRegisterCondition'

/**
 * 帳票作成
 */
export class BatchTrcContentDetailRegisterApi extends runtime.BaseAPI {
  async register(
    request: BatchTrcContentDetailRegisterRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/bibliography/trc-content-detail-register`,
      BatchTrcContentDetailRegisterRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchTrcContentDetailRegisterCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchTrcContentDetailRegisterConditionFromJSON(jsonValue)
    ).value()
  }
}
